import { getWhiteLabelBasePath, getWhiteLabelOptions } from './white-label'

const isMenaHost = () => {
  if (typeof window === 'undefined') return false
  return window.location.hostname.toLowerCase().includes('mena')
}

const getDefaultApiUrl = (): string => {
  if (isMenaHost() && process.env.REACT_APP_API_URL_MENA) {
    return process.env.REACT_APP_API_URL_MENA
  }

  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL
  }

  throw new Error('There is not API URL configured')
}

/**
 * White-label: route the checkout BFF through the merchant proxy. The override
 * supplies the origin and an optional base path (e.g. `https://host/any/path`),
 * which is prefixed to the BFF path so the proxy forwards the same
 * `/checkout-bff/...` route to Yuno: `https://host/any/path/checkout-bff/v1`.
 */
const applyWhiteLabelHost = (url: string, override?: string): string => {
  if (!override) return url

  try {
    const target = new URL(url)
    const source = new URL(override)
    const basePath = getWhiteLabelBasePath(override)
    // Preserve the target's query/hash — a configured REACT_APP_API_URL may carry
    // one (e.g. ?region=eu) that the BFF still needs after the host swap.
    return `${source.origin}${basePath}${target.pathname}${target.search}${target.hash}`
  } catch {
    return url
  }
}

export const Environment = {
  get apiUrl() {
    return applyWhiteLabelHost(getDefaultApiUrl(), getWhiteLabelOptions()?.apiUrl)
  },
}
